import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n\n  & + & {\n    margin-top: ", ";\n  }\n\n  ", " {\n    fill: ", ";\n  }\n\n  ", " {\n    color: ", ";\n  }\n\n  ", " {\n    color: ", ";\n  }\n\n  &:hover,\n  &:focus {\n    ", " {\n      fill: ", ";\n    }\n\n    ", " {\n      color: ", ";\n    }\n\n    ", " {\n      color: ", ";\n    }\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  margin-right: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-grow: 1;\n\n  &::after {\n    border-bottom: 1px dashed ", ";\n    content: '';\n    flex-grow: 1;\n    height: 1em;\n    margin: 0 ", ";\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  margin-right: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { __rest } from "tslib";
import React from 'react';
import styled from 'styled-components';
import { Icon } from '@scp/ui-shared/theme/icons';
import { color } from '@scp/ui-shared/theme/variables';
import { Link, Paragraph } from '@scp/ui-shared/components/typography';
import { FetchingStatus } from '@scp/ui-shared/core';
import { TextLoader } from '@scp/ui-shared/components/loaders/content-loaders';
import { getE2eLabel } from '@scp/ui-shared/components/utils';
import { baselineToRem } from '@scp/ui-shared/theme/utils';
import { ClickableRow } from './ClickableRow';
var COLOR_BY_ROWTYPE = {
  basic: color.action,
  alert: color.alert
};
var NUMBER_COLOR_BY_ROWTYPE = {
  basic: color.textPrimary,
  alert: color.alert
};
var HOVER_COLOR_BY_ROWTYPE = {
  basic: color.actionHover,
  alert: color.alertHover
};
var NUMBER_HOVER_COLOR_BY_ROWTYPE = {
  basic: color.textPrimary,
  alert: color.alertHover
};
var TEXT = {
  E2E_ROW_NUMBER_SUFFIX: '-row-number'
};
var PROPS_TO_OMIT = ['rowType'];
var RowIcon = styled(Icon).attrs({
  size: baselineToRem(5)
})(_templateObject(), baselineToRem(2));
var Text = styled(Link).attrs({
  as: 'span'
})(_templateObject2(), color.border, baselineToRem(2));
var StyledNumber = styled(Paragraph).attrs({
  as: 'span',
  bold: true,
  noMargin: true
})(_templateObject3(), baselineToRem(2));
var Wrapper = styled(ClickableRow).withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !PROPS_TO_OMIT.includes(prop);
  }
})(_templateObject4(), baselineToRem(3), RowIcon, function (props) {
  return COLOR_BY_ROWTYPE[props.rowType];
}, Text, function (props) {
  return COLOR_BY_ROWTYPE[props.rowType];
}, StyledNumber, function (props) {
  return NUMBER_COLOR_BY_ROWTYPE[props.rowType];
}, RowIcon, function (props) {
  return HOVER_COLOR_BY_ROWTYPE[props.rowType];
}, Text, function (props) {
  return HOVER_COLOR_BY_ROWTYPE[props.rowType];
}, StyledNumber, function (props) {
  return NUMBER_HOVER_COLOR_BY_ROWTYPE[props.rowType];
});
export function ClickableRowWithNumber(_a) {
  var text = _a.text,
      number = _a.number,
      _a$numberStatus = _a.numberStatus,
      numberStatus = _a$numberStatus === void 0 ? FetchingStatus.Done : _a$numberStatus,
      _a$external = _a.external,
      external = _a$external === void 0 ? false : _a$external,
      iconName = _a.iconName,
      _a$rowType = _a.rowType,
      rowType = _a$rowType === void 0 ? 'basic' : _a$rowType,
      linkOrButtonProps = __rest(_a, ["text", "number", "numberStatus", "external", "iconName", "rowType"]);

  return React.createElement(Wrapper, Object.assign({}, linkOrButtonProps, {
    rowType: rowType
  }), iconName && React.createElement(RowIcon, {
    name: iconName
  }), React.createElement(Text, null, text), React.createElement(TextLoader, {
    status: numberStatus,
    width: 25
  }, React.createElement(StyledNumber, {
    "data-e2e": getE2eLabel(text, TEXT.E2E_ROW_NUMBER_SUFFIX)
  }, number)), React.createElement(Icon, {
    name: external ? 'launch' : 'keyboard-arrow-right',
    color: external ? color.actionHover : undefined
  }));
}